export default __webpack_public_path__ + "static/media/bathtub-icon.8cd702fb.svg";